import React, { useEffect, useState } from "react";
import axios from "axios";
import { IMAGE_URL, projectname, URL_API } from "../../variable";
import { css } from "@emotion/react";

// reactstrap components
import {
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  Table,
  Row,
  Col,
} from "reactstrap";
import moment from "moment";
import { toast } from "react-toastify";
import { Link, useHistory } from "react-router-dom";
import LOADER from "../../assets/img/barakahhijama.gif";

function PermissionsList() {
  const loaderCss = css`
    margin: auto;
  `;

  const history = useHistory();

  const [permissions, setPermission] = useState([]);
  const [loading, setloading] = useState(true);

  useEffect(() => {
    getPermissions();
    // s=> clearInterval(interval);
  }, []);

  const getPermissions = () => {
    axios.get(URL_API + "auth/admin/permissions").then((response) => {
      if (response.data.status === 200) {
        console.log('permissions', response?.data?.permissions);
        setPermission(response.data.permissions);
        setloading(false)
      }
    });
  };

  const destroySiteSetting = (id) => {

    axios
      .post(URL_API + `auth/admin/site-setting/destroy-site-setting/${id}`)
      .then((response) => {
        if (response.data.status === 200) {
          history.push("/admin/site-setting");
          toast.success("Site Setting Key Deleted Successfully", {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 2000,
          });
          getPermissions();
        }
      });
  };

  return (
    <>
      <div className="content">
        <Row>
          <Col md="12">
            <Card>
              <CardHeader>
                <CardTitle tag="h4" style={{ fontWeight: '100' }}>
                  {projectname} | <i class="fa fa-home" aria-hidden="true"></i> |
                  Permissions
                </CardTitle>
              </CardHeader>
              <div
                style={{
                  paddingLeft: "80%",
                  paddingBottom: "2%",
                  fontSize: "16px",
                }}
              >
                <Link to={`/admin/permission/create`}>
                  <strong>Create Permission + </strong>
                </Link>
              </div>
              <CardBody>
                <Table responsive>

                  {loading == true ? (
                    <>
                      <div className="loader">
                        <img src={LOADER} />
                      </div>
                    </>

                  )

                    :
                    <>
                      <thead className="text-primary">
                        <tr>
                          <th>#</th>
                          <th>Title</th>
                          {/* <th>Value</th> */}
                          <th>Created At</th>
                          <th>Action</th>
                          {/* <th className="text-right">Salary</th> */}
                        </tr>
                      </thead>
                      <tbody>
                        {permissions?.map(
                          (setting, index) => {
                            return (
                              <tr>
                                <td>{index + 1}</td>
                                <td>{setting?.name}</td>
                                {/* <td>{setting?.value}</td> */}
                                <td>
                                  {moment(setting?.created_at).format(
                                    " DD MMMM,YYYY"
                                  )}
                                </td>
                                <td>
                                  {/* <a
                                  style={{ color: "#77ac54" }}
                                  href={`setting/detail/${setting.id}`}
                                >
                                  <i class="fas fa-eye fa-lg"></i>
                                </a>
                                &nbsp;&nbsp;&nbsp;&nbsp; */}
                                  <Link to={`permission/edit/${setting.id}`}>
                                    <i class="far fa-edit fa-lg"></i>
                                  </Link>
                                  &nbsp;&nbsp;&nbsp;&nbsp;
                                  <a
                                    style={{ color: "red" }}
                                    onClick={() => destroySiteSetting(setting.id)}
                                  >
                                    <i class="fas fa-trash-alt fa-lg"></i>
                                  </a>
                                </td>
                              </tr>
                            );
                          }
                          // )
                        )
                        }
                      </tbody>
                    </>
                  }


                </Table>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
}

export default PermissionsList;
